// import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import TeacherCard from "./TeacherCard";
// import TeacherDas1 from "../../../assets/TeacherDas1.png";
// import TeacherDas2 from "../../../assets/TeacherDas2.png";
// import TeacherDas3 from "../../../assets/TeacherDas3.png";
// import { getHitID } from "../../../config/HitIDStorage";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";

// const TeacherDash = () => {
//   const ID = getHitID();
//   const admin = JSON.parse(localStorage.getItem("edo-admin"));
//   const [loading, setLoading] = useState(true); // Add loading state
//   const [data, setData] = useState({ all: 0, home: 0, online: 0 });

//   useEffect(() => {
//     const fetchData = async () => {
// //setIsLoading(true);; // Start loading before data fetch
//       try {
//         const [allStudentsRes, homeStudentsRes, onlineStudentsRes] =
//           await Promise.all([
//             axios.get(
//               `${apiKey}/api/edolutions/admin/read-notifications-all/${ID}`,
//               {
//                 headers: {
//                   Authorization: `Bearer ${admin?.token}`,
//                 },
//               }
//             ),
//             axios.get(
//               `${apiKey}/api/edolutions/admin/read-notifications-home/${ID}`,
//               {
//                 headers: {
//                   Authorization: `Bearer ${admin?.token}`,
//                 },
//               }
//             ),
//             axios.get(
//               `${apiKey}/api/edolutions/admin/read-notifications/${ID}`,
//               {
//                 headers: {
//                   Authorization: `Bearer ${admin?.token}`,
//                 },
//               }
//             ),
//           ]);

//         setData({
//           all: allStudentsRes.data.data.length,
//           home: homeStudentsRes.data.data.length,
//           online: onlineStudentsRes.data.data.length,
//         });
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false); // Stop loading after data fetch
//       }
//     };

//     if (ID) {
//       fetchData();
//     }
//   }, [ID, admin?.token]);

//   return (
//     <>
//       <div>
//         <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//           <div className="w-full border rounded-3xl shadow-xl p-5">
//             <TeacherCard />

//             <div className="flex flex-wrap md:justify-start justify-center space-x-5 border-b-2 text-base font-medium ">
//               <NavLink
//                 to=""
//                 className={({ isActive }) =>
//                   isActive
//                     ? "text-blue-500 border-b-2 border-blue-500"
//                     : undefined
//                 }
//               >
//                 Dashboard
//               </NavLink>

//               <NavLink
//                 to=".././mentor-message"
//                 className={({ isActive }) =>
//                   isActive
//                     ? "text-blue-500 border-b-2 border-blue-500"
//                     : undefined
//                 }
//               >
//                 View Profile
//               </NavLink>

//               <NavLink
//                 to=".././online-sessions"
//                 className={({ isActive }) =>
//                   isActive
//                     ? "text-blue-500 border-b-2 border-blue-500"
//                     : undefined
//                 }
//               >
//                 Online Tutoring
//               </NavLink>

//               <NavLink
//                 to=".././home-tutoring"
//                 className={({ isActive }) =>
//                   isActive
//                     ? "text-blue-500 border-b-2 border-blue-500"
//                     : undefined
//                 }
//               >
//                 Home Tutoring
//               </NavLink>

//               <NavLink
//                 to=".././mentor-chat"
//                 className={({ isActive }) =>
//                   isActive
//                     ? "text-blue-500 border-b-2 border-blue-500"
//                     : undefined
//                 }
//               >
//                 Messages
//               </NavLink>
//             </div>

//             <div>
//               <div className="h-screen">
//                 <div className="mt-5 px-5">
//                   <p className="text-2xl font-semibold">Dashboard</p>
//                 </div>

//                 {loading ? (
//                   <div>
//                     <div colSpan="9" className="py-5 px-1 text-center">
//                       <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                         <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
//                         <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
//                           Cabil...
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="flex flex-wrap items-center justify-center mt-10 gap-5">
//                     <div className="flex items-center space-x-3 px-10 py-8 ">
//                       <div>
//                         <img src={TeacherDas3} alt="" />
//                       </div>
//                       <div>
//                         <p className="text-sm text-[#ACACAC] font-normal">
//                           Home Tuitions
//                         </p>
//                         <p className="text-3xl font-semibold">{data.home}</p>
//                       </div>
//                     </div>
//                     <div className="flex items-center space-x-3 lg:border-l-2 border-0  px-10 py-8">
//                       <div>
//                         <img src={TeacherDas1} alt="" />
//                       </div>
//                       <div>
//                         <p className="text-sm text-[#ACACAC] font-normal">
//                           Online Classes
//                         </p>
//                         <p className="text-3xl font-semibold">{data.online}</p>
//                       </div>
//                     </div>
//                     <div className="flex items-center space-x-3 lg:border-l-2 border-0 px-10 py-8">
//                       <div>
//                         <img src={TeacherDas2} alt="" />
//                       </div>
//                       <div>
//                         <p className="text-sm text-[#ACACAC] font-normal">
//                           Total Students
//                         </p>
//                         <p className="text-3xl font-semibold">{data.all}</p>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TeacherDash;

import React, { useState, useEffect, useMemo } from "react";
import { NavLink, Link } from "react-router-dom";
import TeacherCard from "./TeacherCard";
import TeacherDas1 from "../../../assets/TeacherDas1.png";
import TeacherDas2 from "../../../assets/TeacherDas2.png";
import TeacherDas3 from "../../../assets/TeacherDas3.png";
import { getHitID } from "../../../config/HitIDStorage";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

const TeacherDash = () => {
  const { t } = useTranslation();
  const ID = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));
  const token = admin?.token || "";

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ all: 0, home: 0, online: 0 });
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const [allStudentsRes, homeStudentsRes, onlineStudentsRes] =
          await Promise.all([
            axios.get(
              `${apiKey}/api/edolutions/admin/read-notifications-all/${ID}`,
              { headers: { Authorization: `Bearer ${token}` } }
            ),
            axios.get(
              `${apiKey}/api/edolutions/admin/read-notifications-home/${ID}`,
              { headers: { Authorization: `Bearer ${token}` } }
            ),
            axios.get(
              `${apiKey}/api/edolutions/admin/read-notifications/${ID}`,
              { headers: { Authorization: `Bearer ${token}` } }
            ),
          ]);

        setData({
          all: allStudentsRes?.data?.data?.length || 0,
          home: homeStudentsRes?.data?.data?.length || 0,
          online: onlineStudentsRes?.data?.data?.length || 0,
        });
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(t("adminDash.teacherDash.loadError"));
      } finally {
        setLoading(false);
      }
    };

    if (ID && token) fetchData();
  }, [ID, token]);

  const totalSessions = useMemo(
    () => (data.home || 0) + (data.online || 0),
    [data.home, data.online]
  );
  const homePct = useMemo(
    () => (totalSessions ? Math.round((data.home / totalSessions) * 100) : 0),
    [data.home, totalSessions]
  );
  const onlinePct = useMemo(
    () => (totalSessions ? Math.round((data.online / totalSessions) * 100) : 0),
    [data.online, totalSessions]
  );

  const Skeleton = ({ className = "" }) => (
    <div className={`animate-pulse rounded-2xl bg-gray-100 ${className}`} />
  );

  return (
    <div className="flex items-center xl:p-5 sm:p-0 justify-center">
      <div className="w-full border rounded-3xl shadow-xl p-0 overflow-hidden bg-white">
        {/* Header Card (kept) */}
        <TeacherCard />

        {/* Gradient Hero */}
        <div className="relative mx-5 mt-5 overflow-hidden rounded-3xl bg-gradient-to-tr from-[#EE5F2B] to-[#2A3A54]">
          <div className="absolute -top-16 -right-10 h-48 w-48 rotate-12 rounded-3xl bg-white/10 blur-2xl" />
          <div className="absolute -bottom-10 -left-10 h-40 w-40 -rotate-12 rounded-3xl bg-black/10 blur-2xl" />
          <div className="relative z-10 p-6 md:p-8">
            <div className="flex flex-wrap items-end justify-between gap-4">
              <div>
                <p className="text-white/90 text-sm">{t("adminDash.teacherDash.adminMentorOverview")}</p>
                <h1 className="text-white text-2xl md:text-3xl font-extrabold tracking-tight">
                  {t("adminDash.findTeacher.dashboard")}
                </h1>
              </div>
              <div className="flex gap-2">
                <Link
                  to=".././online-sessions"
                  className="rounded-xl bg-white/15 px-4 py-2 text-white text-sm font-semibold backdrop-blur hover:bg-white/25"
                >
                  {t("adminDash.teacherDash.onlineSessions")}
                </Link>
                {/* <Link
                  to=".././home-tutoring"
                  className="rounded-xl bg-white/15 px-4 py-2 text-white text-sm font-semibold backdrop-blur hover:bg-white/25"
                >
                  Home Tutoring
                </Link> */}
              </div>
            </div>
          </div>
        </div>

        {/* Nav Tabs (pill style) */}
        <div className="mx-5 mt-4">
          <div className="flex flex-wrap gap-2 border-b border-gray-100 pb-2">
            {[
              { to: "", label: t("adminDash.findTeacher.dashboard") },
              { to: ".././mentor-message", label: t("adminDash.homeTutoring.viewProfile") },
              { to: ".././online-sessions", label: t("adminDash.studentDash.sessions") },
              // { to: ".././home-tutoring", label: "Home Tutoring" },
              { to: ".././mentor-chat", label: t("adminDash.messages") },
            ].map((tab) => (
              <NavLink
                key={tab.to || "root"}
                to={tab.to}
                end={tab.to === ""}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${isActive
                    ? "bg-[#EE5F2B]/90 text-white ring-1 ring-[#EE5F2B]"
                    : "text-gray-600 hover:bg-gray-50"
                  }`
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="mx-5 my-6">
          {error && (
            <div className="mb-4 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          {/* Stats + Mix grid */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
            {/* Stat cards */}
            <div className="xl:col-span-2">
              {loading ? (
                <div className="no-scrollbar flex gap-4 overflow-x-auto pb-1">
                  <Skeleton className="h-24 w-60" />
                  <Skeleton className="h-24 w-60" />
                  <Skeleton className="h-24 w-60" />
                </div>
              ) : (
                <div className="no-scrollbar flex gap-4 overflow-x-auto pb-1">
                  {/* <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <img src={TeacherDas3} alt="" className="h-10 w-10" />
                      <div>
                        <p className="text-xs text-gray-500">Home Tuitions</p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {data.home}
                        </p>
                      </div>
                    </div>
                  </div> */}

                  <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <img src={TeacherDas1} alt="" className="h-10 w-10" />
                      <div>
                        <p className="text-xs text-gray-500">{t("adminDash.studentDash.sessions")}</p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {data.online}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <img src={TeacherDas2} alt="" className="h-10 w-10" />
                      <div>
                        <p className="text-xs text-gray-500">{t("adminDash.teacherDash.totalMentees")}</p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {data.all}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Compact cards row */}
              {!loading && (
                <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <p className="text-xs text-gray-500">{t("adminDash.teacherDash.utilization")}</p>
                    <p className="text-lg font-semibold">{totalSessions}</p>
                    <div className="mt-2 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
                      <div
                        className="h-full bg-emerald-400"
                        style={{ width: `${Math.min(totalSessions * 5, 100)}%` }}
                      />
                    </div>
                    <p className="mt-1 text-[11px] text-gray-500">
                      {t("adminDash.teacherDash.sessionsScaledPreview")}
                    </p>
                  </div>

                  {/* <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <p className="text-xs text-gray-500">Home %</p>
                    <p className="text-lg font-semibold">{homePct}%</p>
                    <div className="mt-2 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
                      <div
                        className="h-full bg-emerald-400"
                        style={{ width: `${homePct}%` }}
                      />
                    </div>
                    <p className="mt-1 text-[11px] text-gray-500">Home mix</p>
                  </div> */}

                  <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                    <p className="text-xs text-gray-500">{t("adminDash.teacherDash.sessionsPercent")}</p>
                    <p className="text-lg font-semibold">{onlinePct}%</p>
                    <div className="mt-2 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
                      <div
                        className="h-full bg-indigo-400"
                        style={{ width: `${onlinePct}%` }}
                      />
                    </div>
                    <p className="mt-1 text-[11px] text-gray-500">{t("adminDash.teacherDash.onlineMix")}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Session Mix Panel */}
            <div className="rounded-3xl border border-gray-100 bg-white p-5 shadow-sm">
              <h3 className="text-base font-bold text-gray-900">{t("adminDash.teacherDash.sessionMix")}</h3>
              {loading ? (
                <div className="mt-3 space-y-3">
                  <Skeleton className="h-5 w-full" />
                  <Skeleton className="h-5 w-5/6" />
                  <Skeleton className="h-5 w-4/6" />
                </div>
              ) : (
                <>
                  {/* <div className="mt-3 text-sm text-gray-600">
                    <div className="flex items-center justify-between">
                      <span>Home</span>
                      <span className="font-semibold">{homePct}%</span>
                    </div>
                    <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-gray-100">
                      <div
                        className="h-full bg-emerald-400"
                        style={{ width: `${homePct}%` }}
                      />
                    </div>
                  </div> */}
                  <div className="mt-4 text-sm text-gray-600">
                    <div className="flex items-center justify-between">
                      <span>{t("adminDash.teacherDash.online")}</span>
                      <span className="font-semibold">{onlinePct}%</span>
                    </div>
                    <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-gray-100">
                      <div
                        className="h-full bg-indigo-400"
                        style={{ width: `${onlinePct}%` }}
                      />
                    </div>
                  </div>
                  <p className="mt-3 text-xs text-gray-500">
                    {t("adminDash.teacherDash.totalSessions")}: <span className="font-semibold">{totalSessions}</span>
                  </p>
                </>
              )}
              <div className="mt-5 grid grid-cols-2 gap-3">
                <Link
                  to=".././mentor-chat"
                  className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-center text-sm font-semibold text-gray-700 hover:bg-gray-50"
                >
                  {t("adminDash.messages")}
                </Link>
                <Link
                  to=".././mentor-message"
                  className="rounded-xl bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] px-4 py-2 text-center text-sm font-semibold text-white"
                >
                  {t("adminDash.homeTutoring.viewProfile")}
                </Link>
              </div>
            </div>
          </div>

          {/* Footer callouts */}
          {/* <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
              <p className="text-sm font-semibold text-gray-900">Keep momentum</p>
              <p className="text-xs text-gray-500 mt-1">
                Balance home and online sessions for better reach.
              </p>
            </div>
            <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
              <p className="text-sm font-semibold text-gray-900">Engage students</p>
              <p className="text-xs text-gray-500 mt-1">
                Share class goals early & celebrate small wins.
              </p>
            </div>
            <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
              <p className="text-sm font-semibold text-gray-900">Quick links</p>
              <div className="mt-2 flex flex-wrap gap-2">
                <Link
                  to=".././online-sessions"
                  className="text-xs rounded-full bg-gray-50 px-3 py-1 text-gray-700 border border-gray-200"
                >
                  Online
                </Link>
                <Link
                  to=".././home-tutoring"
                  className="text-xs rounded-full bg-gray-50 px-3 py-1 text-gray-700 border border-gray-200"
                >
                  Home
                </Link>
                <Link
                  to=".././mentor-chat"
                  className="text-xs rounded-full bg-gray-50 px-3 py-1 text-gray-700 border border-gray-200"
                >
                  Chat
                </Link>
              </div>
            </div>
          </div> */}
        </div>

        {/* Fullscreen loader (only when first loading) */}
        {loading && (
          <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
            <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
            <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">Cabil...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherDash;

